module.exports = {
    checkoutConfirmation: {
        deliveryMethodMessagePickup: 'Your order can be collected from',
        deliveryMethodMessageDeliver: 'Your order will be delivered to',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/checkout-confirmation.js